import { Editor, ReactEditor } from '@lumapps/wrex/slate';

import { isTableHeaderCell } from './isTableHeaderCell';

/** Whether the first row of the table at the given path is a header row (its cells are `th`). */
export const isHeaderRow = (editor: ReactEditor, tablePath: number[]) => {
    // The first cell of the first row lives at a fully known path, so read it directly
    // instead of scanning the whole row. Guard against not-yet-normalized/empty tables.
    const firstCellPath = [...tablePath, 0, 0];
    if (!Editor.hasPath(editor, firstCellPath)) {
        return false;
    }
    const [firstCell] = Editor.node(editor, firstCellPath);
    return isTableHeaderCell(firstCell);
};
